import React from 'react';
import { PrimaryButton } from '../ui/Buttons';
import { useSticker } from '../../context/StickerContext';
import { useToast } from '../ui/Toast';
const PRICE_TIERS = [{
  label: '1–250',
  rate: '$0.040'
}, {
  label: '251–500',
  rate: '$0.035'
}, {
  label: '501–750',
  rate: '$0.025'
}, {
  label: '751–1,000',
  rate: '$0.020'
}, {
  label: '1,001+',
  rate: '$0.018'
}];
function fmt(n: number) {
  return n.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  });
}
export function QuantityPanel() {
  const {
    quantity,
    setQuantity,
    totalPrice,
    pricePerSticker,
    rate,
    tierLabel
  } = useSticker();
  const {
    addToast
  } = useToast();
  return <div className="h-full flex flex-col" data-id="element-244">
      <div className="p-4 border-b border-gray-100" data-id="element-245">
        <h2 className="font-semibold text-[#111111]" data-id="element-246">Quantity</h2>
      </div>
      <div className="p-4 space-y-5 overflow-y-auto flex-1" data-id="element-247">
        <div data-id="element-248">
          <label className="text-xs font-medium text-[#5F5F5F] block mb-1" data-id="element-249">
            Number of stickers
          </label>
          <input type="number" min={1} step={1} value={quantity || ''} placeholder="e.g. 100" onChange={e => {
          const val = parseInt(e.target.value, 10);
          setQuantity(isNaN(val) ? 0 : val);
        }} className="w-full rounded-lg border border-[#D9D9D9] px-4 py-2.5 text-sm focus:ring-2 focus:ring-[#008696] focus:border-[#008696] outline-none" data-id="element-250" />
          <p className="text-xs text-[#5F5F5F] mt-1" data-id="element-251">
            Enter the exact quantity you want.
          </p>
        </div>

        {quantity > 0 && <div className="bg-[#EAF6F7] rounded-lg p-3 text-sm" data-id="element-252">
            <div className="flex justify-between mb-1" data-id="element-253">
              <span className="text-[#008696] font-medium" data-id="element-254">Current tier</span>
              <span className="text-[#111111] font-bold" data-id="element-255">{tierLabel}</span>
            </div>
            <div className="flex justify-between" data-id="element-256">
              <span className="text-[#008696]" data-id="element-257">Rate</span>
              <span className="text-[#111111]" data-id="element-258">${rate.toFixed(3)} / sq in</span>
            </div>
          </div>}

        <div data-id="element-259">
          <p className="text-xs font-semibold text-[#5F5F5F] uppercase tracking-wide mb-2" data-id="element-260">
            Pricing Tiers
          </p>
          <div className="space-y-1" data-id="element-261">
            {PRICE_TIERS.map(tier => {
            const isActive = quantity > 0 && tier.label === tierLabel;
            return <div key={tier.label} className={`flex justify-between text-xs px-2 py-1.5 rounded ${isActive ? 'bg-[#EAF6F7] text-[#008696] font-semibold' : 'text-[#5F5F5F]'}`} data-id="element-262">
                  <span data-id="element-263">{tier.label}</span>
                  <span data-id="element-264">{tier.rate} / sq in</span>
                </div>;
          })}
          </div>
          <p className="text-xs text-[#FF0000] mt-3" data-id="element-265">
            Pricing Tiers are based on single images, you can not upload 2 or
            more images in one file and expect us to split the quantity per the
            images.
          </p>
        </div>

        <div className="pt-3 border-t border-gray-100" data-id="element-266">
          <div className="flex justify-between text-sm mb-1" data-id="element-267">
            <span className="text-[#5F5F5F]" data-id="element-268">Price per sticker</span>
            <span className="font-medium text-[#111111]" data-id="element-269">
              {pricePerSticker > 0 ? fmt(pricePerSticker) : '—'}
            </span>
          </div>
          <div className="flex justify-between" data-id="element-270">
            <span className="text-base font-bold text-[#111111]" data-id="element-271">Total</span>
            <span className="text-lg font-bold text-[#111111]" data-id="element-272">
              {totalPrice > 0 ? fmt(totalPrice) : '—'}
            </span>
          </div>
        </div>
      </div>
      <div className="p-4 border-t border-gray-100" data-id="element-273">
        <PrimaryButton className="w-full" onClick={() => addToast('Quantity updated')} disabled={quantity <= 0} data-id="element-274">
          Continue
        </PrimaryButton>
      </div>
    </div>;
}